import { render, staticRenderFns } from "./SettingProfileForm.vue?vue&type=template&id=2fac2d10&scoped=true&"
import script from "./SettingProfileForm.vue?vue&type=script&lang=js&"
export * from "./SettingProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingProfileForm.vue?vue&type=style&index=0&id=2fac2d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac2d10",
  null
  
)

export default component.exports